jQuery(document).foundation();
var $ = jQuery;

$(document).ready(function(){

    $('#home-slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        dots: false,
    });

    const scrollElements = document.querySelectorAll(".js-scroll");

    const elementInView = (el, dividend = 1) => {
    const elementTop = el.getBoundingClientRect().top;

    return (
        elementTop <=
        (window.innerHeight || document.documentElement.clientHeight) / dividend
    );
    };

    const elementOutofView = (el) => {
    const elementTop = el.getBoundingClientRect().top;

    return (
        elementTop > (window.innerHeight || document.documentElement.clientHeight)
    );
    };

    const displayScrollElement = (element) => {
    element.classList.add("scrolled");
    };

    const hideScrollElement = (element) => {
    element.classList.remove("scrolled");
    };

    const handleScrollAnimation = () => {
    scrollElements.forEach((el) => {
        if (elementInView(el, 1.25)) {
        displayScrollElement(el);
        } else if (elementOutofView(el)) {
        hideScrollElement(el)
        }
    })
    }
    handleScrollAnimation();
    window.addEventListener("scroll", () => { 
    handleScrollAnimation();
    });

});
$(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       $('.circle-menu').addClass('small');
    } else {
       $('.circle-menu').removeClass('small');
    }
});